import { TranslateService } from '@ngx-translate/core';

export function replaceTemplatePlaceholders(
  template: string,
  values: { [key: string]: string },
  html: boolean = false
): string {
  if (html)
    return JSON.stringify({
      html,
      value: template.replace(
        /\$\{(\w+)\}/g,
        (placeholder, key) => values[key] || placeholder
      ),
    });
  else
    return template.replace(
      /\$\{(\w+)\}/g,
      (placeholder, key) => values[key] || placeholder
    );
}

export function capitalizeFirstLetter(str: string | null) {
  if (!str || str?.length == 0) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

var hideMissingTranslations = true;
export function t(
  prefix: string,
  value: string,
  translate: TranslateService,
  params?: Object
) {
  const translationKey = `${prefix}.${value}`;
  const translation = translate.instant(translationKey, params);
  if (hideMissingTranslations && translation === translationKey) {
    return value;
  }

  return translation;
}
